export default {
    board:{
        sizeX:3,
        sizeY:3,
        noughtColor:"rgb(20, 70, 220)",
        crossColor:"rgb(220, 40, 20)"
    },
    sidebar:{
        enabled:false,
        components:['playStatus','history'],
        backgroundColor:"blue"
    }
}